import type { Mode, FullMode } from '../domain/Mode'
import { type IconName } from '../ui/components/icon/Icon'

const iconsByMode = {
  less_than_truckload: 'truck-ltl-dryvan',
  partial_truckload: 'truck-ptl-dryvan',
  full_truck_load: 'truck-dryvan',
  intermodal: 'truck-rail-drybox',
  drayage: 'truck-drayage',
  volume_less_than_truckload: 'truck-vltl',
  EXP: 'truck-exp',
}

const iconsByAbbr = {
  LTL: 'truck-ltl-dryvan',
  PTL: 'truck-ptl-dryvan',
  FTL: 'truck-dryvan',
  IMDL: 'truck-rail-drybox',
  DRAY: 'truck-drayage',
  VLTL: 'truck-vltl',
  EXP: 'truck-exp',
}

export function getIconNameByMode(mode: FullMode): IconName {
  return iconsByMode[mode] as IconName
}

export function getIconNameByAbbr(mode: Mode): IconName {
  return iconsByAbbr[mode] as IconName
}

export function formatMode(mode: FullMode) {
  switch (mode) {
    case 'drayage':
      return 'DRAY'
    case 'full_truck_load':
      return 'FTL'
    case 'less_than_truckload':
      return 'LTL'
    case 'partial_truckload':
      return 'PTL'
    case 'intermodal':
      return 'IMDL'
    case 'EXP':
      return 'EXP'
    default:
      return 'N/A'
  }
}
